import PlaceItem from './PlaceItem'

export default PlaceItem
